<div class="response-pill" [class.selected]="selected" (click)="select(!selected)">
  <div class="response-copy">{{ label }}</div>
</div>
